import { jsx as _jsx } from "react/jsx-runtime";
import { AboutIcon, AppDevelopmentIcon, BlogIcon, CertificationIcon, CustomersStoryIcon, HelpCenterIcon, PartnersIcon, SupportIcon, TemplateCenterIcon, WhatsNewIcon, TrustCenterIcon } from "./icons/index.js";
import { ABOUT_US_PAGE_LINK, AI_TRUST_CENTER_SITE_LINK, APPS_DEVELOPER_LINK, BLOG_PAGE_LINK, BUILDERS_CERTIFICATIONS_PAGE_LINK, CUSTOMERS_PAGE_LINK, HELP_CENTER_LINK, PARTNERS_PAGE_LINK, SUPPORT_PAGE_LINK, AI_TEMPLATE_CENTER_AGENT_LINK, TEMPLATE_CENTER_PAGE_LINK, WHATS_NEW_PAGE_LINK } from "constants/links";
const AI_TEMPLATE_CENTER_ICON_URL = "https://dapulse-res.cloudinary.com/image/upload/AI%20homepage%202026/Menu2026-AIPlatfromMulti-product-Union-5A6gV.svg";
const AiTemplateCenterIcon = ()=>/*#__PURE__*/ _jsx("img", {
        src: AI_TEMPLATE_CENTER_ICON_URL,
        alt: "",
        width: 20,
        height: 20
    });
export const LEARN_LINKS = [
    {
        Icon: AboutIcon,
        text: "header.tabs.resources.aboutUs",
        link: ABOUT_US_PAGE_LINK
    },
    {
        Icon: WhatsNewIcon,
        text: "header.tabs.resources.whatsNew",
        link: WHATS_NEW_PAGE_LINK
    },
    {
        Icon: BlogIcon,
        text: "header.tabs.resources.blog",
        link: BLOG_PAGE_LINK
    },
    {
        Icon: CertificationIcon,
        text: "header.tabs.resources.getCertified",
        link: BUILDERS_CERTIFICATIONS_PAGE_LINK
    },
    {
        Icon: CustomersStoryIcon,
        text: "header.tabs.resources.customerStories",
        link: CUSTOMERS_PAGE_LINK
    },
    {
        Icon: TrustCenterIcon,
        text: "header.tabs.products.aiTrustCenter",
        link: AI_TRUST_CENTER_SITE_LINK
    }
];
export const SUPPORT_LINKS = [
    {
        Icon: HelpCenterIcon,
        text: "header.tabs.resources.helpCenter",
        link: HELP_CENTER_LINK
    },
    {
        Icon: SupportIcon,
        text: "header.tabs.resources.support",
        link: SUPPORT_PAGE_LINK
    },
    {
        Icon: PartnersIcon,
        text: "header.tabs.resources.partners",
        link: PARTNERS_PAGE_LINK
    }
];
export const BUILD_LINKS = [
    {
        Icon: AiTemplateCenterIcon,
        text: "header.tabs.resources.aiTemplateCenter",
        link: AI_TEMPLATE_CENTER_AGENT_LINK
    },
    {
        Icon: TemplateCenterIcon,
        text: "header.tabs.resources.solutionTemplates",
        link: TEMPLATE_CENTER_PAGE_LINK
    },
    {
        Icon: AppDevelopmentIcon,
        text: "header.tabs.resources.appDevelopment",
        link: APPS_DEVELOPER_LINK
    }
];
